/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconCheck from '@telus-uds/palette-koodo/build/rn/icons/Check'
const theme = {
  appearances: {
    checked: {
      description: 'Corresponds to a selected state for a checkbox or radio',
      type: 'state',
      values: [ true ]
    },
    error: { type: 'state', values: [ true ] },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    inactive: {
      description: 'Prevents an interactive component from being interacted with and applies accessibility attributes to indicate to the user that this component cannot be used.',
      type: 'state',
      values: [ true ]
    }
  },
  rules: [
    {
      if: { focus: true },
      tokens: { inputOutlineColor: '#000000', inputOutlineWidth: 1 }
    },
    {
      if: { hover: true },
      tokens: { inputOutlineColor: '#000000', inputOutlineWidth: 1 }
    },
    {
      if: { inactive: true },
      tokens: {
        descriptionFontColor: '#666666',
        inputBackgroundColor: '#c9c8c8',
        inputBorderColor: 'rgba(0, 0, 0, 0)',
        labelColor: '#666666'
      }
    },
    {
      if: { checked: true, inactive: true },
      tokens: { iconBackgroundColor: '#c9c8c8', iconColor: '#ffffff' }
    }
  ],
  tokens: {
    containerBackgroundColor: 'rgba(0, 0, 0, 0)',
    descriptionFontColor: '#000000',
    descriptionFontName: 'StagSans',
    descriptionFontSize: 14,
    descriptionFontWeight: '400',
    descriptionLineHeight: 1.4,
    descriptionMarginLeft: null,
    feedbackMarginBottom: 0,
    feedbackMarginTop: 12,
    feedbackPosition: 'bottom',
    icon: PaletteIconCheck,
    iconBackgroundColor: '#ffffff',
    iconColor: '#7a3dfc',
    iconSize: 14,
    inputBackgroundColor: '#ffffff',
    inputBorderColor: '#000000',
    inputBorderRadius: 0,
    inputBorderWidth: 2,
    inputHeight: 20,
    inputOutlineColor: null,
    inputOutlineOffset: 1,
    inputOutlineWidth: 0,
    inputShadow: null,
    inputWidth: 20,
    labelColor: '#000000',
    labelFontName: 'StagSans',
    labelFontSize: 16,
    labelFontWeight: '400',
    labelLineHeight: 1.5,
    labelMarginLeft: 8
  }
}
export default theme
